import createIcon from '../../createIcon';

/**
 * @component @name Compress
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOS41SDExVjIyLjVIMTNWMTkuNUgxNkwxMiAxNS41TDggMTkuNVpNMTYgNC41SDEzVjEuNUgxMVY0LjVIOEwxMiA4LjVMMTYgNC41Wk00IDkuNVYxMS41SDIwVjkuNUg0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgMTIuNUgyMFYxNC41SDRWMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Compress = createIcon('Compress', [
  [
    'path',
    {
      d: 'M8 19.5H11V22.5H13V19.5H16L12 15.5L8 19.5ZM16 4.5H13V1.5H11V4.5H8L12 8.5L16 4.5ZM4 9.5V11.5H20V9.5H4Z',
      key: 'm5w4pw',
    },
  ],
  ['path', { d: 'M4 12.5H20V14.5H4V12.5Z', key: 'ptwczz' }],
]);

export default Compress;
